export default __webpack_public_path__ + "static/media/divider.d5563333.svg";